import { Injectable } from '@angular/core';
import { EventSearchParametersStore } from './event-search-parameters.store';
import { OrderedSet } from 'immutable';
import { EventSearchFilter } from '../models/event-filter';
import { EventMenuSearchFilterMapper } from '../../menus/event-search-filter/event-menu-search-filter-mapper';
import { EventMenuSearchFilter, EventMenuSearchFilterPaymentStatus } from '../models/event-menu-search-filter';

/**
 * This class is used to store the predefined searches such as "missing agency" and "completed and unpaid"
 */
@Injectable()
export class PredefinedSearchService {

  constructor(
    private eventSearchParametersStore: EventSearchParametersStore,
    private eventMenuSearchFilterMapper: EventMenuSearchFilterMapper
  ) {}

  missingAgencySearch(): void {
    const eventMenuSearchFilter: EventMenuSearchFilter = new EventMenuSearchFilter({
      eventStatusMissingAgency: true
    });

    this.eventSearchParametersStore.setDefaultViewSelected(true);
    this.navigate(eventMenuSearchFilter);
  }

  completedAndUnpaid() {
    const paymentStatus = new EventMenuSearchFilterPaymentStatus({
      unpaid: true,
      inProcess: false,
      paid: false
    });

    const eventMenuSearchFilter: EventMenuSearchFilter = new EventMenuSearchFilter({
      paymentStatus: paymentStatus,
      eventStatusCompleted: true
    });

    this.eventSearchParametersStore.setDefaultViewSelected(false);
    this.navigate(eventMenuSearchFilter);
  }

  /**
   * This method should be used by all predefined searches because it handles conversion and navigation
   *
   * @param {EventMenuSearchFilter} eventMenuSearchFilter
   */
  private navigate(eventMenuSearchFilter: EventMenuSearchFilter): void {
    // convert EventMenuSearchFilter to an OrderedSet
    const eventSearchFilterSet: OrderedSet<EventSearchFilter>
      = this.eventMenuSearchFilterMapper.toSearchFilterSet(eventMenuSearchFilter);

    // update the search parameter store and navigate
    const updateUrl = true;
    this.eventSearchParametersStore.setFilterSet(eventSearchFilterSet, updateUrl)
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/predefined-search.service.ts